import Footer from '../components/menu/footer'
import Document from '../components/section/privacy'
import Navbar from '../components/menu/navbar'
import ScrollButton from '../components/button/scroll'
import DocHero from '../components/section/docHero'
import COPY from '../utils/copy'

export default function Privacy() {
  return (
    <>
      <Navbar />
      <DocHero document={COPY.PRIVACY_HEADER} />
      <Document />
      <Footer />
      <ScrollButton />
    </>
  )
}
